// extracted by mini-css-extract-plugin
export default {"centeredSlider":"SliderBanner_centeredSlider__7Jw4Y","sliderBanner":"SliderBanner_sliderBanner__9l+1e","sliderSpace":"SliderBanner_sliderSpace__vZ4wn"};